import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { Provider } from "react-redux";
import store from "./redux/store";
import { BrowserRouter as Router } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <HashRouter>
  <Provider store={store}>
    <Router>
      <App />
    </Router>
  </Provider>
  // </HashRouter>
);
